import styles from './Hero.module.css';

const STATS = [
  ['Since 2007', 'NetSuite', true],
  ['150+', 'Projects', false],
  ['5', 'SaaS Products Built', false],
  ['Full-Stack', 'Capability', false],
  ['AI-Native', 'Solutions', false],
];

export default function Hero() {
  return (
    <section className={styles.hero}>
      <div className="wrap">
        <div className={styles.heroGrid}>
          <div className={`${styles.heroCopy} reveal`}>
            <span className={styles.heroTag}>
              <span className={styles.dot} /> Independent NetSuite expert <b>+ FULL-STACK</b>
            </span>
            <h1>
              NetSuite Expertise
              <span className={styles.plus}>
                <em>+ Full-Stack Innovation</em>
              </span>
            </h1>
            <p className={styles.heroSub}>
              From NetSuite consulting and SuiteScript development to building production-ready SaaS
              platforms, I bring senior-level expertise to every project.
            </p>
            <div className={styles.heroCta}>
              <a href="#contact" className="btn btn-primary">
                Start a Conversation
              </a>
              <a href="#portfolio" className="btn btn-ghost">
                View Portfolio →
              </a>
            </div>
          </div>

          <div className={`${styles.dash} reveal`}>
            <div className={styles.dashBar}>
              <i />
              <i />
              <i />
              <span>jpcw / what-i-do</span>
            </div>
            <div className={styles.dashBody}>
              <div className={styles.dashRow}>
                <h4>What I Do</h4>
                <span className={styles.pill}>3 Pillars</span>
              </div>
              <ul className={styles.capStack}>
                <li>
                  <span className={`${styles.capIc} ${styles.coral}`}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
                      <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" />
                      <path d="M12 12l8-4.5M12 12v9M12 12L4 7.5" />
                    </svg>
                  </span>
                  <span className={styles.capMeta}>
                    <b>NetSuite Expertise</b>
                    <span>Consulting · SuiteScript · integrations</span>
                  </span>
                  <span className={styles.capBar}>
                    <i style={{ width: '96%' }} />
                  </span>
                </li>
                <li>
                  <span className={styles.capIc}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
                      <path d="M8 6l-6 6 6 6M16 6l6 6-6 6" />
                    </svg>
                  </span>
                  <span className={styles.capMeta}>
                    <b>Full-Stack Builds</b>
                    <span>Production SaaS · web &amp; mobile apps</span>
                  </span>
                  <span className={styles.capBar}>
                    <i style={{ width: '88%' }} />
                  </span>
                </li>
                <li>
                  <span className={`${styles.capIc} ${styles.indigo}`}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
                      <circle cx="12" cy="12" r="4" />
                      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" />
                    </svg>
                  </span>
                  <span className={styles.capMeta}>
                    <b>AI Enablement</b>
                    <span>Train your team on NetSuite's AI</span>
                  </span>
                  <span className={`${styles.capBar} ${styles.indigo}`}>
                    <i style={{ width: '80%' }} />
                  </span>
                </li>
              </ul>
              <div className={styles.dashFoot}>
                <span className={styles.dotLive} />
                <p>
                  <b>Principal-led delivery</b> Work directly with me — never a hand-off.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={`${styles.statStrip} reveal`}>
          {STATS.map(([v, k, coral]) => (
            <div className={styles.item} key={k}>
              <div className={`${styles.v} ${coral ? styles.coral : ''}`}>{v}</div>
              <div className={styles.k}>{k}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
